import isObject from 'lodash/isObject';

import { validateObjectFields } from './validatorsNested';

export const objectWidgetValidator = ({ value, field, formatMessage }) => {
  if (!isObject(value) || !field.schema) return null;

  let itemSchema = field.schema;
  if (typeof field.schemaExtender === 'function') {
    itemSchema = field.schemaExtender(field.schema, value, formatMessage);
  }
  if (!itemSchema?.properties) return null;

  const fieldErrors = validateObjectFields({
    schema: itemSchema,
    data: value,
    formatMessage,
    schemaExtender: field.schemaExtender,
  });

  return Object.keys(fieldErrors).length ? fieldErrors : null;
};

export default objectWidgetValidator;
